import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Extra } from '@common/components/Extras/Extra';
import { GuestSelector, ToggleGuestExtra } from '@common/components/Extras/controls';
import { generateGuestOptions } from '@common/components/Extras/utils';
import { SpaEntityFormValues } from '@common/components/SpaEntity/SpaEntityForm.schema';

type RHFExtrasProps = {
  extras: any[];
  selectedGuests: any[];
  fieldPrefix?: string;
  showPrice?: boolean;
  selectedExtras?: Record<string, any>;
};

export const RHFExtras = ({
  extras,
  selectedGuests,
  fieldPrefix = 'extras',
  showPrice = false,
  selectedExtras = {},
}: RHFExtrasProps) => {
  const { control } = useFormContext<SpaEntityFormValues>();

  return (
    <>
      {extras.map(({ id, extra, featured, name, image, price, description }) => {
        const extraId = extra?.id || id;
        const fieldSuffix = `id-${extraId}`;
        const fieldName = `${fieldPrefix}.${fieldSuffix}` as any;
        const guestOptions = generateGuestOptions(selectedGuests, extraId, price);

        return (
          <Extra
            featured={featured}
            name={name}
            image={image}
            price={price}
            description={description}
            showPrice={showPrice}
            key={extraId}
            controls={
              <Controller
                control={control}
                name={fieldName}
                render={({ field: { value, onChange } }) => {
                  const Control = guestOptions.length > 1 ? GuestSelector : ToggleGuestExtra;
                  return (
                    <Control
                      input={{ value, onChange: onChange as any }}
                      options={guestOptions as any}
                    />
                  );
                }}
              />
            }
            isSelected={selectedExtras[fieldSuffix]}
          />
        );
      })}
    </>
  );
};
